<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <device-group />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import DeviceGroup from "./components/DeviceGroup";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    DeviceGroup,
    // ProjectsTable,
  },
};
</script>
